import * as styled from '../styles/featured-review';

const STAR_COUNT = 5;

type Props = {
  review: LandingV2.FeaturedReview;
};

export const FeaturedReview = ({ review }: Props) => (
  <styled.Card>
    {review.serviceName && <styled.ServiceName>{review.serviceName}</styled.ServiceName>}
    <styled.TopRow>
      <styled.Name>{review.reviewerName}</styled.Name>
      <styled.Date>{review.daysAgo}</styled.Date>
    </styled.TopRow>
    <styled.Stars>
      {'★'.repeat(review.rating)}
      {'☆'.repeat(STAR_COUNT - review.rating)}
    </styled.Stars>
    <styled.Comment>&ldquo;{review.comment}&rdquo;</styled.Comment>
  </styled.Card>
);
